import React from 'react';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import moment from 'moment-timezone';

import { ICase, Status } from '@brands/services/cases/types/ICase';

import styles from '../styles.module.scss';
import { getAssignedProviderName } from '../utils/complianceChecklistCopy';

type Props = {
  thisCase: ICase;
  timeZone: string;
};

const ProviderAttestationCard = ({ thisCase, timeZone }: Props): JSX.Element | null => {
  const attestationDate = thisCase.completed_at || (thisCase.status === Status.Completed ? thisCase.updated_at : '');

  if (!attestationDate) return null;

  const providerName = getAssignedProviderName(thisCase.provider?.full_name);
  const formattedAttestationDate = moment.utc(attestationDate).tz(timeZone).format('MM/DD/YYYY [at] hh:mma');

  return (
    <div className={styles.providerAttestationCard}>
      <GppGoodOutlinedIcon className={styles.providerAttestationIcon} />

      <div className={styles.providerAttestationContent}>
        <span className={styles.providerAttestationTitle}>Provider attestation</span>
        <span className={styles.providerAttestationValue}>
          {formattedAttestationDate}
          <span className={styles.providerAttestationSeparator}>|</span>
          {providerName}
        </span>
      </div>
    </div>
  );
};

export default ProviderAttestationCard;
